import { render, staticRenderFns } from "./PostEditImmoOfferZ.vue?vue&type=template&id=b228b3a4&"
import script from "./PostEditImmoOfferZ.vue?vue&type=script&lang=js&"
export * from "./PostEditImmoOfferZ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports